import React, { useRef, useState } from 'react';
import { MAX_QR_BYTES, QR_TYPES, normalizeVoicePayment } from '../utils/voicePayment';

export default function VoicePaymentFields({ payment, onChange }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const selection = useRef(0);
  const update = (key, value) => onChange({ ...payment, [key]: value });
  async function selectQr(event) {
    const file = event.target.files[0];
    const current = ++selection.current;
    onChange({ method: 'paypay' });
    setError('');
    if (!file) { setLoading(false); return; }
    if (!Object.hasOwn(QR_TYPES, file.type) || file.size > MAX_QR_BYTES) {
      setError('PNG・JPEG・WebP形式の1MB以下の画像を選択してください。');
      setLoading(false);
      event.target.value = '';
      return;
    }
    setLoading(true);
    try {
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = () => reject(Error('画像を読み込めませんでした。もう一度選択してください。'));
        reader.readAsDataURL(file);
      });
      const next = normalizeVoicePayment({ method: 'paypay', qr: { contentType: file.type, data: dataUrl.split(',')[1] } });
      if (current === selection.current) onChange(next);
    } catch (failure) {
      if (current === selection.current) setError(failure.message);
    } finally {
      if (current === selection.current) setLoading(false);
    }
  }
  return <section className="voice-payment">
    <h3>報酬の支払先</h3>
    <p className="jobs-note">口座情報とQRコード画像は担当者への応募通知に含まれます。見積共有URLには含まれません。</p>
    <label>支払方法<select value={payment.method} onChange={event => {
      selection.current++; setError(''); setLoading(false);
      onChange({ method: event.target.value, accountType: 'ordinary' });
    }}>
      <option value="later">依頼成立後に連絡する</option>
      <option value="bank">銀行振込</option>
      <option value="paypay">PayPay（QRコード添付）</option>
    </select></label>
    {payment.method === 'bank' && <>
      <label>銀行名<input required maxLength={100} value={payment.bankName || ''} onChange={event => update('bankName', event.target.value)} /></label>
      <label>支店名<input required maxLength={100} value={payment.branchName || ''} onChange={event => update('branchName', event.target.value)} /></label>
      <label>口座種別<select value={payment.accountType} onChange={event => update('accountType', event.target.value)}><option value="ordinary">普通</option><option value="current">当座</option><option value="savings">貯蓄</option></select></label>
      <label>口座番号（7桁）<input required inputMode="numeric" pattern="[0-9]{7}" maxLength={7} value={payment.accountNumber || ''} onChange={event => update('accountNumber', event.target.value)} /></label>
      <label>口座名義（カナ）<input required maxLength={120} value={payment.accountHolder || ''} onChange={event => update('accountHolder', event.target.value)} /></label>
    </>}
    {payment.method === 'paypay' && <>
      <label>PayPayの受け取り用QRコード画像（必須・1MB以下）<input type="file" accept="image/png,image/jpeg,image/webp" required={!payment.qr} onChange={selectQr} /></label>
      <p className="jobs-note">PNG・JPEG・WebP形式。送金先がわかる受け取り用QRコードを添付してください。</p>
      {loading && <p role="status">画像を読み込んでいます…</p>}
      {payment.qr && <img className="voice-payment-qr" src={`data:${payment.qr.contentType};base64,${payment.qr.data}`} alt="添付するPayPay受け取り用QRコード" />}
    </>}
    {error && <p role="alert">{error}</p>}
  </section>;
}
